export const toFormValue = (d: Date | undefined): string => {
  if (!d) {
    return '';
  }
  return `${d.getFullYear()}-${(d.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}T${d
    .getHours()
    .toString()
    .padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
};

// Format a Date as NZST (UTC+12) for a datetime-local input, regardless of browser timezone.
// NPC season (Jul–Oct) is always NZST; hardcoding +12 is correct for that window.
export const toNZFormValue = (d: Date | undefined): string => {
  if (!d) { return ''; }
  const nz = new Date(d.getTime() + 12 * 60 * 60 * 1000);
  return [
    nz.getUTCFullYear(),
    '-',
    String(nz.getUTCMonth() + 1).padStart(2, '0'),
    '-',
    String(nz.getUTCDate()).padStart(2, '0'),
    'T',
    String(nz.getUTCHours()).padStart(2, '0'),
    ':',
    String(nz.getUTCMinutes()).padStart(2, '0'),
  ].join('');
};

// Parse a datetime-local string entered as NZST (UTC+12) back to a UTC Date.
export const fromNZFormValue = (value: string): Date =>
  new Date(`${value}:00+12:00`);

export function formatDate(
  date: Date | string | null | undefined,
  time = false,
) {
  if (!date) {
    return '';
  }
  if (typeof date === 'string') {
    date = new Date(date);
  }
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  };
  if (time) {
    options.hour = 'numeric';
    options.minute = 'numeric';
  }
  return date.toLocaleDateString('en-GB', options);
}

/**
 * Short relative time for status panels ("3m ago", "2d ago").
 * Returns an empty string for a missing timestamp so callers can render it
 * inline without a guard.
 */
export const formatRelativeTime = (iso: string | null | undefined): string => {
  if (!iso) {
    return '';
  }
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) {
    return 'just now';
  }
  if (diff < 3600) {
    return `${Math.floor(diff / 60)}m ago`;
  }
  if (diff < 86400) {
    return `${Math.floor(diff / 3600)}h ago`;
  }
  return `${Math.floor(diff / 86400)}d ago`;
};
